document.addEventListener('algolia.hooks.initialize', function () {
  window.algoliaShopify.hooks.registerHook(
    'beforeISStartAddWidgetArray',
    function (widgets, instantSearchInstance) {

      const { configure } = window.algoliaShopify.externals.widgets;

      const configureWidget = configure({
        distinct: 1,
        facetingAfterDistinct: false
      });

      return [...widgets, configureWidget];
    }
  );
});
